import { Box } from "@mui/material";
import React, { useState } from "react";
import { serializeChildren } from "utils/markdown";
import ContentEditorButton from "components/markdown-editor/ContentEditorButton";

export default function Header({ children, updateParagraph, headerComponent }) {

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      component={headerComponent}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        padding: "8px",
        backgroundColor: isHovered ? "rgba(0,0,255,0.1)" : "transparent",
        transition: "background-color 0.3s ease",
        marginBottom: "16px",
        position: "relative",
      }}
    >
      {isHovered && (
        <ContentEditorButton 
          paragraphContent={serializeChildren(children)}
          updateParagraph={updateParagraph}
        />
      )}
      {children}
    </Box>
  );
}
